<div class="smash-header" [ngClass]="{ 'scroll': scrollActivate }">
    <div class="smash-header-logo" (click)="onGoToUploader($event)" [ngStyle]="{'color': headerColor}"
        [ngClass]="{'no-shadow': shadowOnElementsEnabled !== true}">
        <a [routerLink]="['/']" *ngIf="isLoggedIn">
            <i class="icon-smash_logo_no_chip"></i>
        </a>
        <a [href]="routeToHome" *ngIf="!isLoggedIn">
            <i class="icon-smash_logo_no_chip"></i>
        </a>
    </div>
    <div class="vertical-box" [ngClass]="{'animated': showVerticalLine}" *ngIf="theme?.teasing?.headerLogo" [ngStyle]="{ 'height': verticalLineHeight }">
        <div #collabLogoContainer class="logo-collab-container">
            <img #collabLogo class="logo-collab" (click)="redirectTo()"
                [ngClass]="{'clickable': !!theme?.teasing?.headerUrl}" [ngStyle]="{'transform': logoCollabTranslationX}"
                [src]="theme?.teasing?.headerLogo" (load)="onCollabLogoLoaded()">
        </div>
    </div>
    <div class="right-content">
        <div class="text-collab-container" *ngIf="theme?.teasing?.headerText" (click)="toggleTextCollab()"
            (clickOutside)="closeTextCollab()" [ngStyle]="{'background-color': headerColor}">
            <div class="text-collab" [ngClass]="{'animated-in': showTextCollab, 'animated-out': !showTextCollab}" [ngStyle]="{'color': captionColor}">
                {{ theme?.teasing?.headerText | translate }}
            </div>
        </div>
        <div *ngIf="showMenu && (isMainDomain$ | async) && !isLoggedIn" class="smash-header-cta" [ngClass]="{'no-shadow': shadowOnElementsEnabled !== true}">
            <ng-container *ngIf="headerLocation === 'viewer'; else uploaderCta">
                <a target="_blank" href="{{ hostname }}{{ 'SMASH_HEADER_TRY_FREEMIUM_LINK' | translate }}"><span translate>SMASH_HEADER_TRY_FREEMIUM</span><i class="icon-smash_fusee"></i></a>
            </ng-container>
            <ng-template #uploaderCta>
                <a href="{{ hostname }}{{ 'SMASH_HEADER_GO_PRO_LINK' | translate }}"><span translate>SMASH_HEADER_GO_PRO</span><i class="icon-smash_fusee"></i></a>
            </ng-template>
        </div>
        <ng-container *ngIf="canDisplayToggleUploaderMode()">
            <app-smash-switch-send-receive class="smash-switch-send-receive" (click)=" $event.stopPropagation()" (change)="onSwitchUploaderMode($event)"
                [value]="uploaderMode === 'Dropbox'"></app-smash-switch-send-receive>
        </ng-container>        
        <app-smash-burger-menu class="smash-header-burger" 
            [color]="headerColor" 
            [shadowEnabled]="shadowOnElementsEnabled === true" 
            *ngIf="showMenu"
            (menuToggle)="onToggleMenu($event)" 
            [state]="state"
            [headerLocation]="headerLocation"
            [selectedTeam]="selectedTeam" 
            [isLoggedIn]="isLoggedIn">
        </app-smash-burger-menu>
    </div>
</div>